// notify/Notification/index.js

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './notification.module.css';
import { createPortal } from 'react-dom';
import createContainer from '../createContainer';
import { ReactComponent as Close } from 'assets/icons/Close.svg';
import { ReactComponent as CircleChecked } from 'assets/icons/CircleChecked.svg';
import { ReactComponent as CircleWrong } from 'assets/icons/CircleWrong.svg';

const container = createContainer();
let timeToDelete = 300;
let timeToClose = 5000;

export function Notification({
  color = Color.info,
  autoClose = true,
  onDelete,
  children,
}): JSX.Element {
  const [isClosing, setIsClosing] = React.useState(false);

  React.useEffect(() => {
    if (autoClose) {
      const timeoutId = setTimeout(() => setIsClosing(true), timeToClose);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [autoClose]);

  React.useEffect(() => {
    if (isClosing) {
      const timeoutId = setTimeout(onDelete, timeToDelete);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isClosing]);

  return createPortal(
    <div
      className={cn([
        styles.notification,
        styles[color],
        { [styles.slideIn]: !isClosing },
        { [styles.slideOut]: isClosing },
      ])}
    >
      <div className=" flex gap-2">
        {color === 'success' ? (
          <CircleChecked className="w-6 h-6" stroke="green" strokeWidth={0.2} />
        ) : (
          <CircleWrong className="w-6 h-6" stroke="red" strokeWidth={0.2} />
        )}{' '}
        {children}
      </div>
    </div>,
    container,
  );
}

export const Color = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
};

Notification.propTypes = {
  notificationType: PropTypes.oneOf(Object.keys(Color)),
  children: PropTypes.node,
};
